<template>
  <div class="ui left labeled fluid icon input">
    <div class="ui label">
      <i class="users icon"></i> Search for a Patient
    </div>
    <input type="text" placeholder="You can use Patient ID or Patient Name">
    <i class="search icon"></i>
  </div>
</template>

<script>
	export default {
		data() {
			return {
				msg: 'Hello world!'
			}
		},
    methods: {
		  // TODO: https://codepen.io/AndrewThian/pen/QdeOVa or https://semantic-ui.com/modules/search.html
      // Probably need to pass data upwards to use the filteredList method :)
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/patients/SearchPatients.vue